import * as L from 'leaflet';
import { Util } from 'leaflet';
//@ts-ignore webpack 5 require without *
import tinycolor from 'tinycolor2';
import * as classnames from 'classnames';
import './iconwithlabel.sass';
const _clamp = (x) => Math.min(Math.max(x, 0), 1);
const DeviceIconExt = L.Icon.extend({
    options: {
        iconSize: [32, 32],
        color: '#000000',
        label: '',
        label_visible: false,
        opacity: 1,
        angle: 0,
    },
    initialize(options) {
        Util.setOptions(this, options);
        this.div = document.createElement('div');
        this.div.style.position = 'absolute';
        this.div.innerHTML =
            '\
          <svg style="display:block" width="100%" height="100%" viewBox="0 0 24 24"> \
              <g transform="translate(12, 12)"> \
              <g id="arrow"> \
                  <polygon stroke-linejoin="round" stroke-width="1.7" id="border" points="0,-10.65 6.25991293691,8.61603099009 0,5.82893818304 -6.25991293691,8.61603099009"/> \
                  <polygon points="0,-7.89934221913 4.86156089491,7.0630037121 0,4.89849734631 -4.86156089491,7.0630037121" id="right"/> \
                  <polygon points="0,-7.89934221913 0,4.89849734631 -4.86156089491,7.0630037121" id="left"/> \
              </g> \
              </g> \
          </svg>\
      ';
        this.arrow = this.div.querySelector('#arrow');
        this.left = this.div.querySelector('#left');
        this.right = this.div.querySelector('#right');
        this.border = this.div.querySelector('#border');
        this.label = document.createElement('span');
        this.label.className = 'device-icon-label';
        this.div.appendChild(this.label);
    },
    createShadow() {
        return null;
    },
    createIcon(oldicon) {
        this.div.style.width = `${this.options.iconSize[0]}px`;
        this.div.style.height = `${this.options.iconSize[1]}px`;
        this.div.style.marginLeft = `${-this.options.iconSize[0] / 2}px`;
        this.div.style.marginTop = `${-this.options.iconSize[1] / 2}px`;
        this.div.style.opacity = this.options.opacity;
        const hsv = tinycolor(this.options.color).toHsv();
        const left = tinycolor({
            h: hsv.h,
            s: _clamp(hsv.s * 0.667),
            v: _clamp(hsv.v * 1.111),
        }).toHexString();
        const right = this.options.color;
        const border = tinycolor({
            h: hsv.h,
            s: _clamp(hsv.s * 1.333),
            v: _clamp(hsv.v * 0.889),
        }).toHexString();
        this.left.setAttribute('fill', left);
        this.right.setAttribute('fill', right);
        this.border.setAttribute('stroke', border);
        this.border.setAttribute('fill', border);
        this.arrow.setAttribute('transform', `rotate(${this.options.angle})`);
        this.label.textContent = this.options.label;
        this.label.className = classnames('device-icon-label', {
            'device-icon-label-visible': this.options.label_visible,
        });
        return this.div;
    },
});
export const DeviceIcon = DeviceIconExt.addInitHook(function () { });
